var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"noOverflow"},[_c('v-main',{staticClass:"v1 noOverflow",attrs:{"id":"maincontainer"}},[_c('v-fade-transition',[_c('router-view')],1),_c('VuexSnackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }